// Expose like/unlike handlers for youtubers to the window so inline onclick can call them

function getCsrfToken() {
  const el = document.querySelector('meta[name="csrf-token"]');
  return el ? el.getAttribute('content') : '';
}

function updateYoutuberLikeUI(youtuberId, likesCount, liked) {
  const countEl = document.querySelector(`.youtuber-likes-count-${youtuberId}`);
  if (countEl) countEl.textContent = likesCount;

  const likeBtn = document.querySelector(`.youtuber-like-${youtuberId}`);
  const unlikeBtn = document.querySelector(`.youtuber-unlike-${youtuberId}`);
  if (likeBtn && unlikeBtn) {
    likeBtn.style.display = liked ? 'none' : 'block';
    unlikeBtn.style.display = liked ? 'block' : 'none';
  }
}

async function requestJson(url, options = {}) {
  const resp = await fetch(url, {
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
      ...(options.headers || {}),
    },
    ...options,
  });
  const data = await resp.json();
  return data;
}

async function likeYoutuber(youtuberId) {
  try {
    const data = await requestJson(`/user/youtubers/${youtuberId}/like.json`, { method: 'POST' });
    updateYoutuberLikeUI(youtuberId, data.likes_count, true);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('likeYoutuber error:', e);
  }
}

async function unlikeYoutuber(youtuberId) {
  try {
    const data = await requestJson(`/user/youtubers/${youtuberId}/unlike.json`, { method: 'DELETE' });
    updateYoutuberLikeUI(youtuberId, data.likes_count, false);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('unlikeYoutuber error:', e);
  }
}

// Attach to window so existing onclick handlers work
window.likeYoutuber = likeYoutuber;
window.unlikeYoutuber = unlikeYoutuber;


